module.exports = __webpack_public_path__ + "static/img/40015 (2).493ec8a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40015 (2).webp
// module id = NZCC
// module chunks = 14